import { createStore } from './createStore';

const createTicketStoreConfig = {
  id: 'createTicket',
  initialState: {
    source: null,
    ticket: null,
    selectedFormTemplate: null,
    errors: {},
    mandatoryFieldsOnCreation: [],
    showAdditionalRequester: false,
    suggestions: null,
    ticketDeflectionClientConfigType: 'ALL',
    ticketDeflectionClientList: null,
    isTicketDeflectionActive: false,
    initialized: false
  },
  methods: (set, get) => ({
    setSource: (updatedSource) => {
      set({ source: updatedSource });
    },

    setSelectedFormTemplate: (updatedSelectedFormTemplate) => {
      set({ selectedFormTemplate: updatedSelectedFormTemplate });
    },

    setTicket: (updatedTicket) => {
      set({ ticket: updatedTicket });
    },

    setMandatoryFieldsOnCreation: (updatedMandatoryFieldsOnCreation) => {
      set({ mandatoryFieldsOnCreation: updatedMandatoryFieldsOnCreation });
    },

    setShowAdditionalRequester: (bool) => {
      set({ showAdditionalRequester: bool });
    },

    setSuggestions: (updatedSuggestions) => {
      set({ suggestions: updatedSuggestions });
    },

    setTicketDeflectionClientConfigType: (
      updatedTicketDeflectionClientConfigType
    ) => {
      set({
        ticketDeflectionClientConfigType: updatedTicketDeflectionClientConfigType
      });
    },

    setTicketDeflectionClientList: (updatedTicketDeflectionClientList) => {
      set({ ticketDeflectionClientList: updatedTicketDeflectionClientList });
    },

    setErrors: (updatedErrors) => {
      set({ errors: updatedErrors });
    },

    setIsTicketDeflectionActive: (bool) => {
      set({ isTicketDeflectionActive: bool });
    },

    updateTicketProperty: (updatedProperties) => {
      const currentTicket = get().ticket;
      set({ ticket: { ...currentTicket, ...updatedProperties } });
    },

    setInitialized: (bool) => {
      set({ initialized: bool });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true
  }
};

export const useCreateTicketStore = createStore(createTicketStoreConfig);
